import React from 'react';
import Alert from '@mui/material/Alert';
import useDictionary from '@ui/hooks/useDictionary';
import { IProps } from './IProps';
import { variants } from './variants.enum';

const Component: React.FC<IProps> = ({
    display,
    message,
    severity,
    variant,
}) => {
    const getWord = useDictionary();

    let rootClass: string;
    switch (variant) {
        case variants.modal:
            rootClass = 'alert_modal';
            break;
        case variants.popper:
            rootClass = 'alert_popper';
            break;
        default:
            rootClass = 'alert';
            break;
    }

    if (display && message) {
        return (
            <Alert
                classes={{
                    root: rootClass,
                    message: 'alert__message',
                    icon: 'alert__icon',
                }}
                severity={severity ?? 'error'}
            >
                {getWord(message)}
            </Alert>
        );
    } else {
        return <></>;
    }
};

const AlertComponent = React.memo(Component);

export default AlertComponent;
